import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Grid, Paper, Typography } from '@mui/material';

import THEME from '../theme';

const theme = createTheme(THEME.app);

const MaintenancePage: React.FC = () => (
  <ThemeProvider theme={theme}>
    <Paper sx={{ minHeight: '100vh', background: THEME.loginBackgroundColor ?? '#dcdcdc', borderRadius: 0 }}>
      <Grid
        alignItems="center"
        container
        direction="column"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item sx={{ textAlign: 'center', padding: '2em' }}>
          <Paper
            elevation={24}
            sx={{
              background: '#092455',
              padding: '2em',
              maxWidth: 480,
              textAlign: 'center',
            }}
          >
            <img
              src={THEME.loginLogo}
              alt="Logo"
              style={{ maxWidth: '90%', minWidth: '200px', padding: '10px', marginBottom: '16px', display: 'block', margin: '0 auto 16px' }}
            />
            <Typography variant="body1" sx={{ color: '#fff', lineHeight: 1.7 }}>
              Aufgrund von Wartungsarbeiten ist diese Applikation am 22.06.2026 von 17:00 bis 21:00 nicht erreichbar.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  </ThemeProvider>
);

export default MaintenancePage;
